module.exports = __webpack_public_path__ + "img/client-logo-3.ab78b309.png";